export default [
    {
        name: 'listarCertificadosContabilidade',
        path: '/contabilidade/certificados',
        alias: '/contabilidade/certificados/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'adicionarCertificadoContabilidade',
        path: '/contabilidade/certificados/adicionar',
        component: () => import('../views/Formulario')
    },
    {
        name: 'editarCertificadoContabilidade',
        path: '/contabilidade/certificados/editar/:id',
        component: () => import('../views/Formulario')
    },
    {
        name: 'visualizarCertificadoContabilidade',
        // A origem vai na query (?origem=erp|contador): o id só é único dentro
        // da origem, porque são duas tabelas diferentes.
        path: '/contabilidade/certificados/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
]
